import { LinkOutlined, TeamOutlined } from '@ant-design/icons';
import { landmineNames } from '@mm/constants/landmine-names';
import { useGoogleSheetsCRUDActions } from '@mm/state/actions/GoogleSheetsCRUDActions';
import '../../IntegrationBaseComponent.scss';
import { GoogleAccount } from '@mm/state/interfaces/googleSheet';
import { selectGoogleAccounts } from '@mm/state/selectors/googleSheetSelectors';
import { activeFacebookPageIdSelector } from '@mm/state/selectors/viewSelectors';
import { OAuthPopupActionButton } from '@mm/stateful-components/OAuth/OAuthPopupActionButton';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { ReactComponent as AccountIcon } from '../../../../../../../../layout/BotBuilderSidebar/UserDropdown/UserDropdownIcons/UserFallback.svg';
import { Tooltip } from '@mm/components';
import { Help } from '../KlaviyoIntegrations/KlaviyoHelpLink';

type Props = {
  isAccountConnected: boolean;
  spreadsheetCount: number;
  onClickAddNew: (updatedGoogleAccounts?: GoogleAccount[]) => void;
};

export const GoogleSheetsHeader = (props: Props) => {
  const { isAccountConnected, spreadsheetCount, onClickAddNew } = props;

  const facebookPageId = useSelector(activeFacebookPageIdSelector);
  const accounts = useSelector(selectGoogleAccounts);
  const { getOauthUrl, getAccounts } = useGoogleSheetsCRUDActions();

  return (
    <div className="integrations__header-actions">
      <Help
        link="https://customers.ai/help/l/en/article/eiftlr4g98-google-sheet-integration"
        text="Help Center"
      />
      <Tooltip title="Google Accounts used in connections" placement="bottom">
        {!!accounts.length && (
          <div className="integrations__header-status">
            <AccountIcon className="integrations__header-status-icon" />
            <div className="integrations__header-status-count">
              {accounts.length}
            </div>
            Accounts
          </div>
        )}
      </Tooltip>
      {isAccountConnected ? (
        <>
          <div className="integrations__header-status">
            <LinkOutlined className="integrations__header-status-icon" />
            <div className="integrations__header-status-count">
              {spreadsheetCount}
            </div>
            Connections
          </div>
          <PrimaryButton
            className="integrations__header-add-button-secondary"
            onClick={e => {
              e?.stopPropagation();
              onClickAddNew();
            }}
            color={ButtonColor.secondaryBlue}
            disabled={!accounts.find(acc => !acc.readOnly)}
          >
            Add a Connection
          </PrimaryButton>
        </>
      ) : (
        <OAuthPopupActionButton
          featureFlag="nativeIntegrations"
          landmineName={landmineNames.INTEGRATIONS_NATIVE_INTEGRATIONS}
          fetchOauthPopupUrl={async () => getOauthUrl('post_message')}
          oauthSuccessMessageType="googleAccountConnected"
          onRefreshNeeded={async () => {
            const accounts = await getAccounts(facebookPageId);
            if (accounts?.length) {
              onClickAddNew(accounts);
            }
          }}
          spinnerProps={{ size: 16, width: 32 }}
          buttonProps={{
            color: ButtonColor.secondaryBlue,
            css: { container: 'integrations__header-add-button-secondary' },
          }}
        >
          Add an Account
        </OAuthPopupActionButton>
      )}
    </div>
  );
};
